import React, { useEffect, useState } from "react";
import { getPokemonFrameOffset } from "./pokemon";

const AnimatedMapSprite = ({ pokeName, folder = "events" }) => {
  // State for current animation frame (direction and step)
  const [animState, setAnimState] = useState({
    direction: "down",
    step: 0,
  });

  useEffect(() => {
    const directions = ["up", "left", "down", "right"];
    const interval = setInterval(() => {
      // Randomly pick a new direction and toggle the step (0 or 1)
      const newDirection =
        directions[Math.floor(Math.random() * directions.length)];
      const newStep = (animState.step + 1) % 4;
      setAnimState({ direction: newDirection, step: newStep });
    }, 500); // update every 500ms (adjust as needed)
    return () => clearInterval(interval);
  }, [animState.step]);

  // Calculate background offset using your provided function
  const offset = getPokemonFrameOffset(animState.direction, animState.step);

  return (
    <div
      style={{
        width: 32,
        height: 32,
        backgroundImage: `url(/Maps/Overworld/${pokeName}.png)`,
        backgroundPosition: `-${offset.x}px -${offset.y}px`,
        imageRendering: "pixelated", // Optional: improves crispness on scaled sprites
      }}
    />
  );
};

export default AnimatedMapSprite;
